
export abstract class Instance {
    constructor(
        readonly instanceName: string,
    ) {
    }

    get name(): string {
        return this.instanceName
    }
}
